<template>
  <div class="stripe-form-container">
    <!-- <div ref="card"></div> -->
    <b-row class="" v-if="card_error"
      ><b-col>
        <!-- <div id="card-error" class="my-3">
          <p class="error_validation_message_p_dy">{{ card_error }}</p>
        </div> -->
        <b-alert
          variant="danger"
          :class="{
            'alert-danger-dy': client_name == 'DY',
          }"
          :show="card_error != null"
          >{{ card_error }}
        </b-alert>
      </b-col></b-row
    >
    <b-row class="">
      <b-col md="12">
        <b-form-group
          id="card-name-input-group"
          :class="form_group_class + ' pb-0'"
          label="Card name holder"
          label-for="card_name_holder"
          :card_name_holder="card_name_holder"
          :label-class="label_class"
        >
          <b-form-input
            :class="'form-control ' + input_class"
            id="card_name_holder"
            v-model="card_name_holder"
            type="text"
            placeholder="Card Name Holder"
            
          ></b-form-input> </b-form-group></b-col
    ></b-row>
    <!-- <label>Card Number</label> -->
    <div class="my-3">
      <b-form-group
        id="card-name-input-group"
        :class="form_group_class + ' pb-0'"
        label-for="card-number"
        label="Card number"
        :label-class="label_class"
      >
      </b-form-group>
      <div id="card-number"></div>
    </div>
    <b-row class="my-3" id="">
      <b-col md="6" class="">
        <b-form-group
          id="card-name-input-group"
          :class="form_group_class + ' pb-0'"
          label-for="card-expiry"
          label="Date"
          :label-class="label_class"
        >
        </b-form-group>
        <div id="card-expiry"></div
      ></b-col>
      <b-col md="6" class="">
        <b-form-group
          id="card-name-input-group"
          :class="form_group_class + ' pb-0'"
          label-for="card-cvc"
          label="CVC"
          :label-class="label_class"
        >
        </b-form-group>
        <div id="card-cvc"></div
      ></b-col>
    </b-row>

    <div class="d-flex justify-content-center align-content-center mt-4">
      <b-button
        type="button"
        :variant="button_variant"
        :class="'btn btn-bumblebee ' + button_class"
        @click="purchase"
        :disabled="isLoading"
      >
        <i class="fa-solid fa-spinner fa-spin" v-if="isLoading"></i>
        {{ button_text }}
      </b-button>
    </div>
    <div class="d-flex justify-content-center align-content-center mb-3 mt-4">
      <img src="@/assets/images/stripe-logo.png" class="w-25" />
    </div>
  </div>
</template>

<!-- <script src="https://js.stripe.com/v3/"></script> -->

<script>
// console.log('here is ', this.process.env.VUE_APP_STRIPE_SECRET)
let stripe = Stripe(
    // "pk_test_51HlxJsJs0xpQGogFbpLLfJQqWLrWGUQvzskO03ksiMewViQ9S4Dbmn9ON1hMNuoNLxuwC4EFkxjFAqiCbrD0NAwy00xU3OnBeN"
    "pk_test_51Qh7E1G2pNTZjroEGJb9DFWsmTBCJVDkr51WGFOcW5iJHioIFh0CY4ghQbgW5OZ0sT3R8s5gvglzWUF2KbWgTjLf00TgplXTom"
  ),
  stripeElements = stripe.elements(),
  card = undefined;
let elementClasses = {
  base: "form-control form-control-auth form-control-auth-doom-yoga",
  focus: "focus",
  empty: "empty",
  invalid: "invalid",
};

// let options = {
// hidePostalCode: true,
// placeholder: "Card number",
// classes: elementClasses,
let style = {
  base: {
    color: "#000",
    "::placeholder": {
      color: "#aaa",
    },
    fontWeight: "400",
    fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
    fontSize: "16px",
    lineHeight: "22px",
    // backgroundColor: "#393939",
    // color: "#fff",
    // "border-radius": "8px",
    // 'padding': "12px",

    // iconColor: "#c4f0ff",
    // fontWeight: "500",
    // fontFamily: "Futura LT",
    // fontSize: "16px",
    // fontSmoothing: "antialiased",
    // ":-webkit-autofill": {
    //   color: "#fce883",
    // },
  },

  invalid: {
    // All of the error styles go inside of here.
    // color: "#00ff00",
  },
};
// };

import axios from "axios";
import $ from "jquery";

export default {
  name: "StripeForm",
  props: [
    "client_name",
    "form_group_class",
    "label_class",
    "input_class",
    "button_text",
    "button_variant",
    "button_class",
    "pricePlan"
  ],
  data() {
    return {
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      card_name_holder: null,
      card_error: null,
      isLoading: false
    };
  },
  mounted() {
    elementClasses.base = "form-control " + this.input_class;
    // console.log(options);
    // card = elements.create("card", options);
    // card.mount(this.$refs.card);
    this.cardNumber = stripeElements.create("cardNumber", {
      classes: elementClasses,
      style: style,
      placeholder: "Card number",
    });
    this.cardNumber.mount("#card-number");
    // options.placeholder = "MM / YY";
    this.cardExpiry = stripeElements.create("cardExpiry", {
      classes: elementClasses,
      style: style,
    });
    this.cardExpiry.mount("#card-expiry");
    // options.placeholder = "CVC";
    this.cardCvc = stripeElements.create("cardCvc", {
      classes: elementClasses,
      style: style,
    });
    this.cardCvc.mount("#card-cvc");
  },
  methods: {
    purchase: function () {
      let temp = this;
      this.isLoading = true
      stripe.createToken(this.cardNumber).then(function (result) {
        // Access the token with result.token
        console.log(result);
        if (result.error != null) {
          // handle error here
          console.log(result.error);
          temp.card_error = result.error.message;
          temp.isLoading = false
          return;
        } else {
          temp.card_error = null;
          temp.token = result.token.id;
          temp.createStripeCustomer();
        }
      });
      //  const { token, error } = await stripe.createToken(this.cardNumber);
      // if (error) {
      //   // handle error here
      //   document.getElementById('card-error').innerHTML = error.message;
      //   return;
      // }
      // console.log(token);
    },
    async createStripeCustomer() {
      const temp = this
      axios.post("/payment/stripe/customer/create", {
        stripe_token: this.token,
      },{
          headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: this.client_name,
              Authorization:
                  "Bearer " +
                  JSON.parse(window.localStorage.getItem("user")).access_token,
          },
      }).then(res => {
          console.log(res);
          temp.createUserSubscription(res);
      }).catch(err => {
          console.log(err);
      })
    },
    updateUserSubscription(res) {
      let authedUser = JSON.parse(window.localStorage.getItem("user"));
      authedUser.has_subscription = true
      authedUser.subscription_details = res.data.subscription_details

      localStorage.setItem("user", JSON.stringify(authedUser));
      this.$router.push({
        name: "GardenHelpMyJobs",
      });
      window.location.reload();
      return true;
    },
    createUserSubscription() {
      let temp = this
    axios.post("/payment/stripe/subscriptions/subscriptions", {
        price_id: this.pricePlan.id
    },{
          headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: this.client_name,
              Authorization:
                  "Bearer " +
                  JSON.parse(window.localStorage.getItem("user")).access_token,
          },
      }).then(res => {
          console.log(res);
          temp.isLoading = false
          temp.updateUserSubscription(res);
      }).catch(err => {
          console.log(err);
      })
  },
  },
  beforeDestroy() {
    // card.destroy(this.$refs.card);
    this.cardNumber.destroy();
    this.cardExpiry.destroy();
    this.cardCvc.destroy();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Payment/StripeForm.vue